<script>
import { markRaw, watch, ref, nextTick } from 'vue';
import router from '@/router/index';
import DefaultLayout from './DefaultLayout.vue';
import FooterLayout from './FooterLayout.vue';
import MenuTopLayout from './MenuTopLayout.vue';
import EmptyLayout from './EmptyLayout.vue';
import MenuLeftLayout from './MenuLeftLayout.vue';

export default {
  name: 'AppLayout',
};
</script>
<script setup>

const layoutMap = {
  DefaultLayout,
  FooterLayout,
  MenuTopLayout,
  EmptyLayout,
  MenuLeftLayout,
};

const defaultLayout = 'DefaultLayout';
const layout = ref();
let previousLayoutName = null;

function changeRoute() {
  if (router.currentRoute.value.name) {
    const layoutName = router.currentRoute.value.meta.layout || defaultLayout;

    if (layoutName !== previousLayoutName) {
      layout.value = markRaw(layoutMap[layoutName] || layoutMap[defaultLayout]);
      previousLayoutName = layoutName;
      return true;
    }
  }
  return false;
}

watch(() => router.currentRoute.value, () => {
  const layoutChanged = changeRoute();

  if (layoutChanged) {
    nextTick(() => {
      if (window.$.app.menu && window.$('.main-menu-content').length > 0) {
        window.$.app.menu.init();

        if (window.$.app.nav) {
          window.$.app.nav.initialized = false;
          window.$.app.nav.init();
        }
      }
    });
  }
}, { immediate: true });
</script>

<template>
  <component :is="layout">
    <slot />
  </component>
</template>
